import { defineComponent as _defineComponent } from 'vue'
import VueMultiselect from "vue-multiselect"
import { ref, watch } from 'vue'

const r = 'required'


export default /*#__PURE__*/_defineComponent({
  __name: 'Multiselect',
  props: {
  errors: {
    type: Object,
    default: () => ({}),
  },
  disabled: Boolean,
  isSuccess: Boolean,
  multiple: Boolean,
  inputLabel: String,
  staticLabel: String,
  options: Array,
  labelBy: String,
  trackBy: String,
  allowEmpty: Boolean,
  placeholder: String,
  pagination: Object,
  showObserveVisibility: Boolean,
  value: Object,
  hideClearBtn: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'text',
  },
  rules: {
    type: String,
    default: '',
  },
  setValue: {},
},
  emits: ['getItems', 'clearMultiselect'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const props = __props

const model = ref(props.value)

watch(() => props.value, () => {
  // if (typeof props.value === 'string') {
  //   let sourcesValue = props.value!.trim().split(/\s+|,\s+?/)
  //   sourcesValue = sourcesValue.filter(el => el != '')
  //   if ( sourcesValue.length > 1 ) {
  //     model.value = sourcesValue
  //   }
  // } else {
  //   model.value = props.value
  // }
  if (typeof props.value !== 'string') {
    model.value = props.value
  }
})

const isRequired = props.rules.includes(r)
const isValid = ref(null)

const emit = __emit

async function visibilityChanged (isVisible) {
  if( isVisible ) {
    await emit('getItems')
  }
}

const clearMultiselect = () => {
  model.value = []
  emit('clearMultiselect')
}



const __returned__ = { props, r, model, isRequired, isValid, emit, visibilityChanged, clearMultiselect, get VueMultiselect() { return VueMultiselect }, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})